import React, { FC } from 'react';
import { View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { isPhone } from '@helpers';
import ImageOverlay from '@components/common/ImageOverlay';
import type { DashboardResultImageData } from '@api/domain/types';

import { ROW_LAYOUT } from '@v2/pages/dashboard/common/constants/rows';
import { useManageDashboardRowImage } from './hooks/useManageDashboardRowImage';
import { ContainerStyle } from '@interfaces/base';

interface DashboardRowImageProps extends WithColor, ContainerStyle {
  imageHash?: string | null;
  imageData?: DashboardResultImageData | null;
}

const DashboardRowImage: FC<DashboardRowImageProps> = ({ C, imageHash, imageData, containerStyle }) => {
  const { uri } = useManageDashboardRowImage({ imageHash, imageData });

  if (isPhone) return null;

  return (
    <View
      style={[
        {
          width: scale(ROW_LAYOUT.image.width),
          height: scale(ROW_LAYOUT.image.height),
          borderRadius: scale(ROW_LAYOUT.image.borderRadius),
          overflow: 'hidden',
          backgroundColor: C('Overlay/Light/Dim light'),
        },
        containerStyle,
      ]}
    >
      {uri && (
        <ImageOverlay
          C={C}
          source={{ uri }}
          resizeMode="cover"
          style={{ width: '100%', height: '100%' }}
          borderRadius={scale(ROW_LAYOUT.image.borderRadius)}
          backgroundColor={'Overlay/Light/Dim light'}
        />
      )}
    </View>
  );
};

export default ColorWrapper(DashboardRowImage);
